module.exports = __webpack_public_path__ + "media/images/placeholders-avatar-2376cd5335dda9970ba7a48e10b5ede5.svg";